import { combineReducers } from 'redux'

import * as ActionTypes from './actionTypes'
import * as IncidentActionTypes from '../incidents/actionTypes'

import { EDIT_MODES, FETCH_STATUS } from '../constants'

export const NAME = 'buffer'

const fetchStatus = (state = FETCH_STATUS.NOT_YET_FETCHED, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return FETCH_STATUS.FETCHING
    case ActionTypes.FETCH_FAILURE:
      return FETCH_STATUS.FETCH_FAILED
    case ActionTypes.FETCH_SUCCESS:
      return FETCH_STATUS.LOADED
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.buffers &&
        action.buffers.forEach(buffer => (byId[buffer.layerId] = buffer))
      return byId
    case ActionTypes.FETCH_START:
      return {}
    case ActionTypes.SAVE:
    case ActionTypes.CREATE:
      return {
        ...state,
        [action.buffer.layerId]: action.buffer
      }
    case ActionTypes.REMOVE:
      return {
        ...state,
        [action.layerId]: undefined
      }
    default:
      return state
  }
}

const allKeys = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_START:
      return []
    case ActionTypes.FETCH_SUCCESS:
      return action.buffers.map(buffer => buffer.layerId)
    case ActionTypes.CREATE:
      if (state.indexOf(action.buffer.layerId) === -1) {
        return [...state, action.buffer.layerId]
      } else {
        return state
      }
    case ActionTypes.REMOVE:
      return state.filter(layerId => layerId !== action.layerId)
    default:
      return state
  }
}

const visible = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_SUCCESS:
      let byId = {}
      action.buffers.forEach(buffer => (byId[buffer.layerId] = true))
      return byId
    case ActionTypes.CREATE:
      return {
        ...state,
        [action.buffer.layerId]: true
      }
    case ActionTypes.FETCH_START:
      return {}
    case ActionTypes.HIDE:
      return {
        ...state,
        [action.layerId]: false
      }
    case ActionTypes.SHOW:
      return {
        ...state,
        [action.layerId]: true
      }
    default:
      return state
  }
}

const hovered = (state = null, action) => {
  switch (action.type) {
    case ActionTypes.HOVER:
      return action.layerId
    case ActionTypes.END_HOVER:
      return null
    default:
      return state
  }
}

const selected = (state = -1, action) => {
  switch (action.type) {
    case IncidentActionTypes.SELECT_INCIDENTS:
    case IncidentActionTypes.CLEAR_SELECTION:
    case ActionTypes.DESELECT:
      return -1
    case ActionTypes.SELECT:
      return action.layerId
    default:
      return state
  }
}

const initialEditorState = {
  open: false,
  mode: EDIT_MODES.NEW,
  initialBuffer: {},
  buffer: {}
}

const editor = (state = initialEditorState, action) => {
  switch (action.type) {
    case ActionTypes.OPEN_EDITOR:
      return {
        ...state,
        open: true,
        mode: action.mode,
        buffer: { ...action.buffer },
        initialBuffer: action.buffer
      }
    case ActionTypes.SET_EDIT_DISTANCE:
      return {
        ...state,
        buffer: {
          ...state.buffer,
          distance: action.distance
        }
      }
    case ActionTypes.SET_EDIT_LAYER:
      return {
        ...state,
        buffer: {
          ...state.buffer,
          layerId: action.layerId
        }
      }
    case ActionTypes.SET_EDIT_UNIT:
      return {
        ...state,
        buffer: {
          ...state.buffer,
          unit: action.unit
        }
      }
    case ActionTypes.SAVE:
    case ActionTypes.CREATE:
    case ActionTypes.REMOVE:
    case ActionTypes.CLOSE_EDITOR:
      return initialEditorState
    default:
      return state
  }
}

const clean = (state = true, action) => {
  switch (action.type) {
    case ActionTypes.SAVE:
    case ActionTypes.CREATE:
    case ActionTypes.REMOVE:
      return false
    case ActionTypes.FETCH_SUCCESS:
    case ActionTypes.MARK_CLEAN:
      return true
    default:
      return state
  }
}

export default combineReducers({
  fetchStatus,
  allKeys,
  byId,
  visible,
  selected,
  hovered,
  editor,
  clean
})
